/** Plain-text helpers for PG home activity feed (no JSX). */

export const PG_ACTIVITY_MAX_DESC_LEN = 160;

export function escapeRegExp(s) {
  return String(s).replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
}

export function getKeywordsForActivityItem(item) {
  const status = String(item?.status || "").toLowerCase();
  if (status === "active") return ["submitted"];
  if (status === "approved")
    return String(item?.bond_type || "").toLowerCase() === "blanket"
      ? ["Created"]
      : ["Approved"];
  if (status === "cancelled" || status === "canceled") return ["Cancelled"];
  if (status === "endorsed") return ["endorsed"];
  if (status === "updated") return ["Data Correction", "changed"];
  return [];
}

export function getActivityFeedDescription(item) {
  const status = String(item?.status || "").toLowerCase();
  const bondType = item?.bond_type || "—";
  const name = item?.name || "—";
  const requester = item?.requester_name || "A user";
  if (status === "active")
    return `${requester} submitted a ${bondType} bond for ${name}, please review.`;
  if (status === "approved") {
    if (String(bondType).toLowerCase() === "blanket")
      return `The Verification Certificate for ${requester} for ${name} was Created, please review.`;
    return `The ${bondType} bond requested by ${requester} for ${name} was Approved, please review.`;
  }
  if (status === "cancelled" || status === "canceled")
    return `The ${bondType} bond requested by ${requester} for ${name} was Cancelled, please review.`;
  if (status === "endorsed") {
    const byName = item?.contact_name || requester;
    const desc = item?.endorsement_description ? `, ${item.endorsement_description}` : "";
    return `The ${bondType} bond for ${name} was endorsed by ${byName}${desc}, please review.`;
  }
  if (status === "updated") {
    const field = item?.field_name;
    const oldV = item?.old_value ?? "—";
    const newV = item?.new_value ?? "—";
    const change = field ? `, ${field} changed from ${oldV} to ${newV}` : "";
    return `Data Correction was applied on ${bondType} bond for ${name} by ${requester}${change}, please review.`;
  }
  return `${requester} submitted a ${bondType} bond for ${name}, please review.`;
}
